import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent, Stack, Typography, Modal, Tooltip as TT, IconButton, ButtonGroup, Grid } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';

import { selectGlobalSettingEntities } from '../../../reducers/reference_settings';
import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import { useNavigate, createSearchParams } from 'react-router-dom'

const AssessmentEditButton = ( props) => {
    const row = props.row
    const navigate = useNavigate()
    const { user: currentUser } = useSelector((state) => state.auth);
    const settings = useSelector(state => selectGlobalSettingEntities(state))
    const viewInstance = useSelector(state => selectViewInstanceById(state, "ProfileDemographics"))
    const PrevAsmtsText = viewInstance?.ProfileVI?.MenuProfile?.PreviousAssessmentsFrame.PreviousAssessmentTextObject ?
        viewInstance.ProfileVI.MenuProfile.PreviousAssessmentsFrame.PreviousAssessmentTextObject
        : {}
    const [guid, setGuid] = useState("")
    const [open, setOpen] = useState(false)
    const handleStartEdit = (row) => {
        if (row.AssmtGuid) {
            fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + settings.session["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' + row.AssessmentProductGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
                .then(fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + row.AssmtGuid + '/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }
                })
                    .then(response => {

                        navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701', assmtguid: row.AssmtGuid }).toString() })
                    })
                )
        }
    }
    const handleEditClick = (row) => {

        setOpen(true)
        setGuid(guid)
    }
    const handleClose = () => {
        setOpen(false)
    }
    return (
        <Box display={(row.CanEdit ==='0' || row.EditAssessmentVisible==='0') ? "none":"block"}>
            <Modal
                open={open}
                onClose={handleClose}>
                <Box sx={{
                    position: "absolute",
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { sm: 500, xs: 400 },
                    padding: "15px",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    boxShadow: 24, '& button': { m: 1 }
                }}>
                    <Typography variant="h5">{PrevAsmtsText.EditAssessmentWarning.Text}</Typography>
                    <Button variant="contained" size="large" onClick={() => handleStartEdit(row)}>{PrevAsmtsText.EditAssessmentWarning.Continue}</Button>
                    <Button variant="outlined" size="large" onClick={() => handleClose()}>{PrevAsmtsText.EditAssessmentWarning.Exit}</Button>
                </Box>
            </Modal>
            <TT title={PrevAsmtsText.EditAssessmentText}>
                <IconButton variant="text" onClick={() => handleEditClick(row)} >
                    <EditIcon />
                </IconButton>
            </TT>
        </Box>

    )

}

export default AssessmentEditButton